import { styled } from '@mui/material';

export const StyledLayoutContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  width: '100%',
  height: '100vh',
  backgroundRepeat: 'no-repeat',
  backgroundImage:
      'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
    ...theme.applyStyles('dark', {
      backgroundImage:
        'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
    }),
}));